import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'errorReport',
    serviceName: 'shopadmin',
    query: gql`
      query errorReport(
        $ids: [String]
        $shop_id: String
        $product_id: String
        $product_shop_id: String
        $creator_id: String
        $done_by_id: String
        $status: String # 'todo','doing','rejected','done'
        $done: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        errorReport(
          ids: $ids
          shop_id: $shop_id
          product_id: $product_id
          product_shop_id: $product_shop_id
          creator_id: $creator_id
          done_by_id: $done_by_id
          status: $status
          done: $done
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            status
            done_date
            product_name
            product_brand
            product_details
            product_category
            product_image
            product_image_quality
            product_unit
            product_booth
            max_number_buy
            min_number_buy
            location
            status
            description
            created_at
            updated_at
            shop {
              id
            }
            product {
              id
            }
            product_shop {
              id
              product_info {
                id
                title
                barcode
                media {
                  full_url
                }
              }
            }
            creator {
              id
              firstname
              lastname
            }
            done_by {
              id
            }
          }
          total
          per_page
          current_page
          from
          to
          last_page
          has_more_pages
        }
      }
    `,
  },
  delete: {
    name: 'deleteeErrorReport',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteeErrorReport($ids: [String]!) {
        deleteErrorReport(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query listProduct($ids: [String]) {
        product(ids: $ids) {
          total
          last_page
          data {
            id
            title
            media {
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
